// extracted by mini-css-extract-plugin
module.exports = {"hero_wrapper":"heroSection_hero_wrapper___fugL","banner_image":"heroSection_banner_image__MbhG1","nav_btn":"heroSection_nav_btn__1Fi4V"};